// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { useState } from 'react'
import { useOutletContext } from 'react-router-dom'
import { SortingState } from '@teamnine/pcj-ui-v2'

import ArchivedPracticesView from '@/app/CustomerManagement/views/ArchivedPracticesView'
import { CustomerOutletContext } from './types'

export default function ArchivedPractices() {
  const { archivedPractices, currentCustomer, isLoading } =
    useOutletContext<CustomerOutletContext>()
  const [searchString, setSearchString] = useState('')
  const [archivedSortState, setArchivedSortState] = useState<SortingState>([])
  const [archivedPracticesPageIndex, setArchivedPracticesPageIndex] =
    useState(0)

  const handleSearch = (val: string[]) => {
    setSearchString(val[0])
    setArchivedPracticesPageIndex(0)
  }

  return (
    <ArchivedPracticesView
      archivedPractices={archivedPractices}
      currentCustomer={currentCustomer}
      isLoading={isLoading}
      searchString={searchString}
      archivedSortState={archivedSortState}
      archivedPracticesPageIndex={archivedPracticesPageIndex}
      onSortingChange={setArchivedSortState}
      onPageChange={setArchivedPracticesPageIndex}
      onSearch={handleSearch}
    />
  )
}
